/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { Card } from "../..";
import "./styles.scss";

// Local Definitions

import { Message } from "./common";
import ConversationContext from "./Context";
const baseClassName = styleNames.base;
const componentClassName = 'conversation';

/**
 * This is the component description.
 */
const Conversation = ({
  id,
  className: userClassName,
  style,
  ourColor,
  theirColor,
  children,
  backgroundColor
  // ...otherProps
}) => /*#__PURE__*/React.createElement(ConversationContext.Provider, {
  value: {
    ourColor,
    theirColor
  }
}, /*#__PURE__*/React.createElement(Card, {
  id: id,
  className: [baseClassName, componentClassName, userClassName, `y-${backgroundColor}`].filter(e => e).join(' '),
  style: style
}, /*#__PURE__*/React.createElement(Card.Section, null, children)));
Conversation.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The base color to our messages component
   */
  ourColor: PropTypes.string,
  /**
   * The base color to their messages component
   */
  theirColor: PropTypes.string,
  /**
   *  The children JSX
   */
  children: PropTypes.node,
  /**
   * The background color
   */
  backgroundColor: PropTypes.string
};
Conversation.defaultProps = {
  ourColor: 'main',
  theirColor: 'main2',
  backgroundColor: 'background-near'
};
Conversation.Message = Message;
export default Conversation;